














import Vue from 'vue'
import { Icon, LatLng, latLng } from 'leaflet'
import { LMap, LTileLayer, LMarker, LIcon } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'

type D = Icon.Default & {
  _getIconUrl?: string
};

interface ComponentData {
  map: LMap | undefined
  url: string
  attribution: string
  zoom: number
  center: LatLng
  marker: LatLng
}

export default Vue.extend({
  name: 'Map',

  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon
  },

  props: {
    geoLat: String,
    geoLon: String
  },

  data (): ComponentData {
    return {
      map: undefined,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 17,
      center: latLng(0, 0),
      marker: latLng(0, 0),
    }
  },

  watch: {
    geoLat(newVal: string): void {
      if(newVal) {
        this.center = latLng(parseFloat(newVal), parseFloat(this.geoLon))
        this.marker = latLng(parseFloat(newVal), parseFloat(this.geoLon))
      }
    },

    geoLon(newVal: string): void {
      if(newVal) {
        this.center = latLng(parseFloat(this.geoLat), parseFloat(newVal))
        this.marker = latLng(parseFloat(this.geoLat), parseFloat(newVal))
      }
    }
  },

  computed: {
    dynamicSize (): any {
      return [32, 32]
    },

    dynamicAnchor (): number[] {
      return [10, 21]
    },
  },

  methods: {

  },

  mounted () {
    delete (Icon.Default.prototype as D)._getIconUrl
    this.map = this.$refs.myMap as LMap
    //@ts-ignore
    this.map.mapObject.addControl(new window.L.Control.Fullscreen())
    this.center = latLng(parseFloat(this.geoLat), parseFloat(this.geoLon))
    this.marker = latLng(parseFloat(this.geoLat), parseFloat(this.geoLon))
  }

})
